import {RIF} from '../../lib'
import {AdherenceGarminDirect, DigestDay} from '../../model'
import {CheckBlackIcon} from '../../asset/image'
import {Color} from '../../store/state/theme/theme_init_state'

export const AdherenceDeviceDataTypeCollectStateEntry = (props: {
  digestDay: DigestDay
  color: Color
  dataTypeToView?: keyof AdherenceGarminDirect
}) => {
  const {digestDay, color, dataTypeToView} = props
  const viewDataTypeCollected = dataTypeToView ? digestDay?.garminDirectAdherence?.[dataTypeToView] : false
  return (
    <div css={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
      {RIF(
        viewDataTypeCollected,
        <>
          <img src={CheckBlackIcon} width='13' css={{marginRight: '5px'}} />
          <span>collected</span>
        </>,
      )}
      {RIF(!viewDataTypeCollected, <div css={{color: color.grey_160}}>----</div>)}
    </div>
  )
}
